import { render, staticRenderFns } from "./SectionCategoriesKpiCards.vue?vue&type=template&id=2aba666d"
import script from "./SectionCategoriesKpiCards.vue?vue&type=script&lang=ts"
export * from "./SectionCategoriesKpiCards.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports